<template>
    <div>
          <div
            style="height: auto; max-height: calc(100vh - 100px); overflow: auto;"
            class="modal-content p-4"
          >
            <div>
              <div style="text-align: center; margin-bottom: 20px;">
                <h1 style="font-weight: 600; font-size: 20px;">
                  Subject :
                  {{ pdfDetails.note[0].has_all_subject ? "General" : getSubjects() }}
                </h1>
               
              </div>
            </div>
            <div>
              <p style="font-weight: 600; font-size: 20px">
                {{ pdfDetails.note[0].title }}
              </p>
              <h1
                style="font-weight: 400; font-size: 16px"
                v-html="pdfDetails.note[0].body"
              ></h1>
              <p style="margin-bottom: 20px; line-height: 33px">
                {{ pdfDetails.note[0].description }}
              </p>
              <!-- <p style="margin: 0; line-height: 33px;">vel accumsan ante dictum.</p> -->
              <div v-if="pdfDetails.note[0].files.length > 0">
                <div
                  v-for="(file, index) in pdfDetails.note[0].files"
                  :key="index"
                  style="
                    background: #e6f5f6;
                    border-radius: 10px;
                    padding: 25px 12px;
                    margin: 10px 0;
                  "
                >
                    <i
                      v-if="file.file_type.includes('pdf')"
                      class="material-icons"
                      style="color: teal"
                      >picture_as_pdf</i
                    >
                    <i
                      v-else-if="file.file_type.includes('video')"
                      class="material-icons"
                      style="color: teal"
                      >ondemand_video</i
                    >
                    <img
                      v-else-if="file.file_type.includes('image')  || file.file_type.includes('png') || file.file_type.includes('jpg') "
                      :src="file.file_path"
                      style="max-width: 100%"
                    />
  
                    <i
                      v-else-if="file.file_type.includes('audio')"
                      class="material-icons"
                      style="color: teal"
                      >audiotrack</i
                    >
                    <svg
                      v-else-if="
                        file.file_type.includes('doc') ||
                        file.file_type.includes('docx')
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="40"
                      height="40"
                      viewBox="0 0 172 172"
                      style="fill: #000000"
                    >
                      <g
                        fill="none"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                        style="mix-blend-mode: normal"
                      >
                        <path d="M0,172v-172h172v172z" fill="none"></path>
                        <g fill="#9b59b6">
                          <path
                            d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                    <span v-else class="material-icons-outlined">
                      description
                    </span>
                  </div>
                 
              </div>
  
              <div v-else>No Files Available</div>
            </div>
          </div>
    </div>
  </template>
<script>
export default {
  watch: {
    isTopicDetailsView () {
      if (!this.isTopicDetailsView) {
        this.$emit('isTopicDetailsViewClose', true)
      }
    }
  },
  mounted () {
    console.log(this.pdfDetails)
  },
  props: {
    isTopicDetailsView: {
      default: false
    },
    pdfDetails: {
      default: {}
    }
  },
  methods: {
    getSubjects () {
      const pdfs = this.pdfDetails.subjects
      const allTagsArr = pdfs.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      return allTagsArr.join(', ')
    },
    getCourses () {
      const courses = this.pdfDetails.course
      const allTagsArr = courses.map((e) => {
        if (e.name) {
          return e.name
        }
      })
      return allTagsArr.join(', ')
    }
  }
}
</script>